import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from "react-bootstrap";
import Painel from "./pages/Painel/index.js";
import NoticeModal from "./components/NoticeModal";
import { shouldShowNoticeModal } from "./utils/noticeModal";

import "./App.css";

import Routes from "./routes";

async function loadNoticeModal() {
  try {
    const response = await axios.get(
      `${process.env.PUBLIC_URL || ""}/notice-modal.json`
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null;
    }

    console.error("Erro ao carregar o aviso modal.", error);
    return null;
  }
}

function App() {
  const [noticeModal, setNoticeModal] = useState(null);

  useEffect(() => {
    let mounted = true;

    loadNoticeModal().then((config) => {
      if (!mounted) {
        return;
      }

      setNoticeModal(shouldShowNoticeModal(config) ? config : null);
    });

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <main>
      <Painel />
      <Container>
        <Routes />
      </Container>
      {noticeModal ? (
        <NoticeModal config={noticeModal} onClose={() => setNoticeModal(null)} />
      ) : null}
    </main>
  );
}

export default App;
